import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/faq/Manage-my-account-q8-02.png")